import { EmptyState, IconEdit, SecondaryButton } from '@procurify/ui'
import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import { BudgetCategoryCardEmptyStateStyled } from './styles/BudgetCategoryCardEmptyStateStyled'
import messages from '../../messages'

export interface IBudgetCategoryCardEmptyStateProps {
  onClickEditCategoryButton?: () => void
}

export const BudgetCategoryCardEmptyState = ({
  onClickEditCategoryButton,
}: IBudgetCategoryCardEmptyStateProps) => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())
  return (
    <BudgetCategoryCardEmptyStateStyled>
      <EmptyState
        header={intl.formatMessage(
          isFlexibleSpendTrackingEnabled
            ? messages.noCurrentDateRange
            : messages.oldNoCurrentDateRange
        )}
        button={
          onClickEditCategoryButton ? (
            <SecondaryButton
              iconComponent={<IconEdit />}
              onClick={() => onClickEditCategoryButton()}
            >
              {intl.formatMessage(
                isFlexibleSpendTrackingEnabled
                  ? messages.editBudget
                  : messages.editCategory
              )}
            </SecondaryButton>
          ) : null
        }
      />
    </BudgetCategoryCardEmptyStateStyled>
  )
}

BudgetCategoryCardEmptyState.displayName = 'BudgetCategoryCardEmptyState'
